export const unitsEn = {
    number: 'N°',

    time: {
        hours: 'Hours'
    }
}
